import { takeLatest, put, call, select } from 'redux-saga/effects'
import { FETCH_TUTOR, FETCH_TUTOR_FAIL, FETCH_TUTOR_SUCCESS } from '../redux/tutorReducer'
import { RootReducer } from '../redux/rootReducer'
import apiCall from '../helpers/apiCall'

function* FetchTutorFlow(): Generator<any, void, any> {
  const TTL = 1000 * 60 * 1 // 1 minute
  try {
    const lastFetchedAt = yield select((state: RootReducer) => state.tutorReducer.lastFetchedAt)
    if (lastFetchedAt && Date.now() - new Date(lastFetchedAt).getTime() < TTL) {
      return
    }
    const response = yield call(apiCall, { endpoint: '/tutors/tutors', method: 'GET', params: {} })
    yield put(FETCH_TUTOR_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_TUTOR_FAIL())
    console.log(error)
  }
}

export default function* FetchTutorSaga(): Generator<any, void, any> {
  yield takeLatest([FETCH_TUTOR], FetchTutorFlow)
}
